<template>
  <div>
    <!-- Hero Section -->
    <header class="pt-20 pb-20 mt-20 relative h-[400px] sm:h-[500px] md:h-[600px] bg-cover bg-center bgtest1"
      >
      <div class="absolute inset-0 bg-black bg-opacity-60 sm:bg-opacity-50"></div>
      <div class="relative max-w-[1440px] mx-auto px-4 sm:px-8 h-full flex items-center">
        <div class="w-full text-white sm:max-w-2xl">
          <h1 class="mb-4 text-3xl font-bold playfair sm:text-4xl md:text-5xl sm:mb-6">{{ $t('views.About.034262-0') }}</h1>
          <p class="mb-6 text-base leading-relaxed sm:text-lg md:text-xl sm:mb-8">
            {{ $t('views.About.034262-1') }}</p>
          <button
          @click="jumpTo(1)" 
            class="hidden px-6 py-3 text-white transition-all bg-primary rounded-button hover:bg-opacity-90 whitespace-nowrap sm:inline-block">{{ $t('views.About.034262-2') }}</button>
        </div>
      </div>
    </header>

    <!-- 关于我们内容 -->
    <section class="py-12 bg-white sm:py-16 md:py-20">
      <div class="max-w-[1440px] mx-auto px-4 sm:px-8">
        <!-- 移动端布局 -->
        <div class="block lg:hidden">
          <div class="mb-8">
            <h2 class="mb-4 text-3xl font-bold text-gray-800 playfair sm:text-4xl sm:mb-6">{{ $t('views.About.034262-3') }}</h2>
            <div class="w-20 h-1 mb-6 bg-primary sm:mb-8"></div>
          </div>
          <div class="mb-8">
            <img src="../assets/images/075481465723705ca584f7bb261065f0.jpg" alt="我们的办公室"
              class="w-full h-[300px] sm:h-[400px] object-cover rounded-lg shadow-xl">
          </div>
          <div>
            <p class="mb-6 leading-relaxed text-gray-600">
              {{ $t('views.About.034262-4') }}</p>
            <p class="mb-8 leading-relaxed text-gray-600">{{ $t('views.About.034262-5') }}</p>
            <div class="grid grid-cols-2 gap-6 sm:gap-8">
              <div>
                <h3 class="mb-2 text-3xl font-bold sm:text-4xl text-primary">30+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-6') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-3xl font-bold sm:text-4xl text-primary">5000+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-7') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-3xl font-bold sm:text-4xl text-primary">98%</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-8') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-3xl font-bold sm:text-4xl text-primary">15+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-9') }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 桌面端布局 -->
        <div class="items-center hidden gap-16 lg:flex">
          <div class="w-1/2">
            <img src="../assets/images/075481465723705ca584f7bb261065f0.jpg" alt="我们的办公室"
              class="w-full h-[500px] object-cover rounded-lg shadow-xl">
          </div>
          <div class="w-1/2">
            <h2 class="mb-6 text-4xl font-bold text-gray-800 playfair">{{ $t('views.About.034262-3') }}</h2>
            <div class="w-20 h-1 mb-8 bg-primary"></div>
            <p class="mb-6 leading-relaxed text-gray-600">
              {{ $t('views.About.034262-4') }}</p>
            <p class="mb-8 leading-relaxed text-gray-600">{{ $t('views.About.034262-5') }}</p>
            <div class="grid grid-cols-2 gap-8">
              <div>
                <h3 class="mb-2 text-4xl font-bold text-primary">30+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-6') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-4xl font-bold text-primary">5000+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-7') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-4xl font-bold text-primary">98%</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-8') }}</p>
              </div>
              <div>
                <h3 class="mb-2 text-4xl font-bold text-primary">15+</h3>
                <p class="text-gray-600">{{ $t('views.About.034262-9') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心价值观 -->
    <section class="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div class="max-w-[1440px] mx-auto px-4 sm:px-8">
        <div class="mb-10 text-center sm:mb-16">
          <h2 class="mb-4 text-3xl font-bold text-gray-800 playfair sm:text-4xl sm:mb-6">{{ $t('views.About.034262-10') }}</h2>
          <div class="w-20 h-1 mx-auto bg-primary"></div>
        </div>
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 sm:gap-8 lg:gap-12">
          <div
            class="p-6 text-center transition-transform transform bg-white rounded-lg shadow-lg sm:p-8 lg:p-10 hover:scale-105">
            <div
              class="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 sm:w-16 sm:h-16 bg-primary-10 sm:mb-6">
              <i class="text-xl fas fa-star text-primary sm:text-2xl"></i>
            </div>
            <h3 class="mb-3 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-4">{{ $t('views.About.034262-11') }}</h3>
            <p class="text-sm text-gray-600 sm:text-base">{{ $t('views.About.034262-12') }}</p>
          </div>
          <div
            class="p-6 text-center transition-transform transform bg-white rounded-lg shadow-lg sm:p-8 lg:p-10 hover:scale-105">
            <div
              class="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 sm:w-16 sm:h-16 bg-primary-10 sm:mb-6">
              <i class="text-xl fas fa-handshake text-primary sm:text-2xl"></i>
            </div>
            <h3 class="mb-3 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-4">{{ $t('views.About.034262-13') }}</h3>
            <p class="text-sm text-gray-600 sm:text-base">{{ $t('views.About.034262-14') }}</p>
          </div>
          <div
            class="p-6 text-center transition-transform transform bg-white rounded-lg shadow-lg sm:p-8 lg:p-10 hover:scale-105">
            <div
              class="flex items-center justify-center mx-auto mb-4 rounded-full w-14 h-14 sm:w-16 sm:h-16 bg-primary-10 sm:mb-6">
              <i class="text-xl fas fa-gem text-primary sm:text-2xl"></i>
            </div>
            <h3 class="mb-3 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-4">{{ $t('views.About.034262-15') }}</h3>
            <p class="text-sm text-gray-600 sm:text-base">{{ $t('views.About.034262-16') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 领导团队 -->
    <section class="py-12 bg-white sm:py-16 md:py-20">
      <div class="max-w-[1440px] mx-auto px-4 sm:px-8">
        <div class="mb-10 text-center sm:mb-16">
          <h2 class="mb-4 text-3xl font-bold text-gray-800 playfair sm:text-4xl sm:mb-6">{{ $t('views.About.034262-17') }}</h2>
          <div class="w-20 h-1 mx-auto bg-primary"></div>
        </div>
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 sm:gap-8">
          <div class="text-center">
            <div class="relative mb-4 sm:mb-6 group">
              <img src="../assets/images/d1447d43e316843c9b3016e96e7ebcb5.jpg" :alt="$t('views.About.034262-19')"
                class="w-full rounded-lg shadow-lg">
              <div
                class="absolute inset-0 flex items-center justify-center transition-opacity rounded-lg opacity-0 bg-primary bg-opacity-20 group-hover:opacity-100">
                <div class="flex space-x-4">
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-linkedin"></i></a>
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-twitter"></i></a>
                </div>
              </div>
            </div>
            <h3 class="mb-1 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-2">{{ $t('views.About.034262-18') }}</h3>
            <p class="mb-1 text-primary sm:mb-2">{{ $t('views.About.034262-19') }}</p>
            <p class="text-xs text-gray-600 sm:text-sm">{{ $t('views.About.034262-20') }}</p>
          </div>
          <div class="text-center">
            <div class="relative mb-4 sm:mb-6 group">
              <img src="../assets/images/023e86acf1e125a52e3ac786f50f23db.jpg" :alt="$t('views.About.034262-22')"
                class="w-full rounded-lg shadow-lg">
              <div
                class="absolute inset-0 flex items-center justify-center transition-opacity rounded-lg opacity-0 bg-primary bg-opacity-20 group-hover:opacity-100">
                <div class="flex space-x-4">
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-linkedin"></i></a>
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-twitter"></i></a>
                </div>
              </div>
            </div>
            <h3 class="mb-1 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-2">{{ $t('views.About.034262-21') }}</h3>
            <p class="mb-1 text-primary sm:mb-2">{{ $t('views.About.034262-22') }}</p>
            <p class="text-xs text-gray-600 sm:text-sm">{{ $t('views.About.034262-23') }}</p>
          </div>
          <div class="text-center">
            <div class="relative mb-4 sm:mb-6 group">
              <img src="../assets/images/70b79de90c52d5324e24e604da03d184.jpg" :alt="$t('views.About.034262-25')"
                class="w-full rounded-lg shadow-lg">
              <div
                class="absolute inset-0 flex items-center justify-center transition-opacity rounded-lg opacity-0 bg-primary bg-opacity-20 group-hover:opacity-100">
                <div class="flex space-x-4">
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-linkedin"></i></a>
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-twitter"></i></a>
                </div>
              </div>
            </div>
            <h3 class="mb-1 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-2">{{ $t('views.About.034262-24') }}</h3>
            <p class="mb-1 text-primary sm:mb-2">{{ $t('views.About.034262-25') }}</p>
            <p class="text-xs text-gray-600 sm:text-sm">{{ $t('views.About.034262-26') }}</p>
          </div>
          <div class="text-center">
            <div class="relative mb-4 sm:mb-6 group">
              <img src="../assets/images/469e899afd9245c804cff96f71bb3e6e.jpg" :alt="$t('views.About.034262-28')"
                class="w-full rounded-lg shadow-lg">
              <div
                class="absolute inset-0 flex items-center justify-center transition-opacity rounded-lg opacity-0 bg-primary bg-opacity-20 group-hover:opacity-100">
                <div class="flex space-x-4">
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-linkedin"></i></a>
                  <a href="#" class="text-white hover:text-gray-200"><i class="text-xl fab fa-twitter"></i></a>
                </div>
              </div>
            </div>
            <h3 class="mb-1 text-lg font-semibold text-gray-800 sm:text-xl sm:mb-2">{{ $t('views.About.034262-27') }}</h3>
            <p class="mb-1 text-primary sm:mb-2">{{ $t('views.About.034262-28') }}</p>
            <p class="text-xs text-gray-600 sm:text-sm">{{ $t('views.About.034262-29') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.About.034262-30') }} -->
    <section class="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div class="max-w-[1440px] mx-auto px-4 sm:px-8">
        <div class="mb-10 text-center sm:mb-16">
          <h2 class="mb-4 text-3xl font-bold text-gray-800 playfair sm:text-4xl sm:mb-6">{{ $t('views.About.034262-30') }}</h2>
          <div class="w-20 h-1 mx-auto mb-6 bg-primary sm:mb-8"></div>
          <p class="max-w-2xl px-4 mx-auto text-gray-600">{{ $t('views.About.034262-31') }}</p>
        </div>
        <div class="relative h-[300px] sm:h-[400px] md:h-[500px] rounded-lg overflow-hidden shadow-lg">
          <img src="https://ai-public.mastergo.com/gen_page/map_placeholder_1280x720.png" alt="全球办事处地图"
            class="object-cover w-full h-full">
          <div class="absolute inset-0 bg-black bg-opacity-30 sm:bg-opacity-20"></div>
        </div>
      </div>
    </section>

    <!-- {{ $t('views.About.034262-32') }} -->
    <!-- <section class="py-12 bg-white sm:py-16 md:py-20">
      <div class="max-w-[1440px] mx-auto px-4 sm:px-8">
        <div class="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
          <div>
            <h2 class="mb-4 text-3xl font-bold text-gray-800 playfair sm:text-4xl sm:mb-6">{{ $t('views.About.034262-32') }}</h2>
            <div class="w-20 h-1 mb-6 bg-primary sm:mb-8"></div>
            <div class="space-y-6">
              <div class="flex items-start space-x-4">
                <div
                  class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full sm:w-12 sm:h-12 bg-primary-10">
                  <i class="text-lg fas fa-map-marker-alt text-primary sm:text-xl"></i>
                </div>
                <div>
                  <h3 class="mb-1 font-semibold text-gray-800 sm:mb-2">{{ $t('views.About.034262-33') }}</h3>
                  <p class="text-sm text-gray-600 sm:text-base">{{ $t('views.About.034262-34') }}<br>{{ $t('views.About.034262-35') }}</p>
                </div>
              </div>
              <div class="flex items-start space-x-4">
                <div
                  class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full sm:w-12 sm:h-12 bg-primary-10">
                  <i class="text-lg fas fa-phone text-primary sm:text-xl"></i>
                </div>
                <div>
                  <h3 class="mb-1 font-semibold text-gray-800 sm:mb-2">{{ $t('views.About.034262-36') }}</h3>
                  <p class="text-sm text-gray-600 sm:text-base">+1 (212) 555-0123</p>
                </div>
              </div>
              <div class="flex items-start space-x-4">
                <div
                  class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full sm:w-12 sm:h-12 bg-primary-10">
                  <i class="text-lg fas fa-envelope text-primary sm:text-xl"></i>
                </div>
                <div>
                  <h3 class="mb-1 font-semibold text-gray-800 sm:mb-2">{{ $t('views.About.034262-37') }}</h3>
                  <p class="text-sm text-gray-600 sm:text-base">contact@prestigeproperties.com</p>
                </div>
              </div>
              <div class="flex items-start space-x-4">
                <div
                  class="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full sm:w-12 sm:h-12 bg-primary-10">
                  <i class="text-lg fas fa-clock text-primary sm:text-xl"></i>
                </div>
                <div>
                  <h3 class="mb-1 font-semibold text-gray-800 sm:mb-2">{{ $t('views.About.034262-38') }}</h3>
                  <p class="text-sm text-gray-600 sm:text-base">{{ $t('views.About.034262-39') }}<br>{{ $t('views.About.034262-40') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <form class="p-6 rounded-lg shadow-lg bg-gray-50 sm:p-8">
              <h3 class="mb-6 text-xl font-semibold text-gray-800 sm:text-2xl">{{ $t('views.About.034262-32') }}</h3>
              <div class="space-y-4 sm:space-y-6">
                <div>
                  <label class="block mb-2 text-sm text-gray-700 sm:text-base">{{ $t('views.About.034262-41') }}</label>
                  <input type="text"
                    class="w-full px-4 py-2 text-sm border border-gray-300 rounded-button focus:outline-none focus:border-primary sm:text-base"
                    :placeholder="$t('views.About.034262-42')">
                </div>
                <div>
                  <label class="block mb-2 text-sm text-gray-700 sm:text-base">{{ $t('views.About.034262-37') }}</label>
                  <input type="email"
                    class="w-full px-4 py-2 text-sm border border-gray-300 rounded-button focus:outline-none focus:border-primary sm:text-base"
                    :placeholder="$t('views.About.034262-43')">
                </div>
                <div>
                  <label class="block mb-2 text-sm text-gray-700 sm:text-base">{{ $t('views.About.034262-44') }}</label>
                  <textarea
                    class="w-full h-24 px-4 py-2 text-sm border border-gray-300 rounded-button focus:outline-none focus:border-primary sm:h-32 sm:text-base"
                    :placeholder="$t('views.About.034262-45')"></textarea>
                </div>
                <button
                  class="w-full py-2 text-sm text-white transition-all bg-primary sm:py-3 rounded-button hover:bg-opacity-90 whitespace-nowrap sm:text-base">{{ $t('views.About.034262-46') }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import navigation from '@/mixins/navigation'
export default {
  mixins: [navigation],
  name: 'AboutPage',

  mounted() {
    // 页面加载后执行的逻辑
    console.log(this.$t('views.About.034262-47'));
  },

  beforeDestroy() {
    // 页面销毁前执行的清理逻辑
  },

  methods: {
    // 可以在这里添加页面方法
  }
}
</script>
<style scoped>
.bgtest1{
  background-image: url('../assets/images/fea10103ce2bccb536a9547438421d55.jpg')
}
</style>